/**
 * Roles API (用户端只读) - 拉取已启用的角色列表, 供军师页选择.
 *
 * 后端: GET /roles (Bearer) -> Role[]  (普通数组, 非分页; 后端只返回 enabled=true 的角色,
 * 已按 sort_order 升序).
 */
import { http } from './client'
import type { Role } from '@/types/api'

export async function listRoles(): Promise<Role[]> {
  const res = await http.get<Role[]>('/roles')
  return res.data
}
